import React from 'react';

const NotFound = () => <div className="pageContainer">Page not found</div>;

export default NotFound;
